import React from "react";
import { MapPin } from "lucide-react";
import { OORDEEL_LABEL, OORDEEL_TONE, beoordeeldTekst, nietGoedTekst } from "./bezoekUtils";
import { Fotos } from "./Fotos";

export const BezoekKop = ({ b, rechts }) => (
  <div className="flex flex-wrap items-start gap-x-3 gap-y-1">
    <MapPin className="h-5 w-5 text-blue-600 mt-1 shrink-0" />
    <div className="min-w-0 flex-1">
      <h1 data-testid="bezoek-titel" className="font-heading text-2xl font-black tracking-tight text-zinc-900">{b.locatie}</h1>
      <p className="text-sm text-zinc-500">
        Bezoek van <span data-testid="bezoek-datum" className="font-semibold">{b.datumLabel}</span> · <span data-testid="bezoek-auteur">{b.omNaam}</span>
        {" · "}<span data-testid="bezoek-beoordeeld">{beoordeeldTekst(b.beoordeeld)}</span>
        {b.nietGoed > 0 && <span data-testid="bezoek-niet-goed" className="text-rose-700 font-semibold"> · {nietGoedTekst(b.nietGoed)}</span>}
      </p>
    </div>
    {rechts}
  </div>
);

export const RegelLezen = ({ r }) => (
  <li data-testid={`bezoek-regel-${r.id}`} className="bg-white border border-zinc-200 rounded-[10px] p-3 space-y-1.5">
    <div className="flex items-start justify-between gap-3">
      <span className="text-sm font-semibold text-zinc-800">{r.tekst}{r.vervallen && <span data-testid={`bezoek-vervallen-${r.id}`} className="ml-2 text-[10px] font-normal uppercase tracking-wider text-zinc-400">Niet meer in de checklist</span>}</span>
      {r.oordeel ? <span data-testid={`bezoek-oordeel-${r.id}`} className={`shrink-0 text-xs font-semibold rounded-full border px-2 py-0.5 ${OORDEEL_TONE[r.oordeel]}`}>{OORDEEL_LABEL[r.oordeel]}</span>
        : <span data-testid={`bezoek-oordeel-${r.id}`} className="shrink-0 text-xs text-zinc-400">Niet beoordeeld</span>}
    </div>
    {r.bevinding?.trim() && <p data-testid={`bezoek-bevinding-${r.id}`} className="text-sm text-zinc-700 whitespace-pre-wrap break-words">{r.bevinding}</p>}
  </li>
);

// Alleen lezen: dezelfde opbouw als bewerken, zonder invoer.
export const BezoekLezen = ({ b }) => (
  <div data-testid="bezoek-lezen" className="space-y-5">
    <BezoekKop b={b} />
    <ol className="space-y-2">{b.regels.map((r) => <RegelLezen key={r.id} r={r} />)}</ol>
    <Fotos bezoek={b} magBewerken={false} onBezoek={() => {}} />
  </div>
);
